import { SourcingService } from 'api-clients/monolith';

import { DateRangeFilter } from '@/contexts/table-context';

export type ReachBreakdown = Awaited<
  ReturnType<
    typeof SourcingService.getInternalApiSourcingCampaignsReachBreakdown
  >
>;

export function getReachBreakdown(purchaseId: string, dates: DateRangeFilter) {
  return SourcingService.getInternalApiSourcingCampaignsReachBreakdown(
    purchaseId,
    dates.preset,
    dates.startDate,
    dates.endDate,
  );
}
